import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 12v.01","key":"svg-0"}],["path",{"d":"M3 21h18","key":"svg-1"}],["path",{"d":"M5 21v-16a2 2 0 0 1 2 -2h6m4 10.5v7.5","key":"svg-2"}],["path",{"d":"M21 7h-7m3 -3l-3 3l3 3","key":"svg-3"}]]

const IconDoorEnter = createReactComponent('outline', 'door-enter', 'DoorEnter', __iconNode);

export default IconDoorEnter;